<script setup>
import { ChevronRight, Plus } from 'lucide-vue-next'
import { ref } from 'vue'
import { useConversationStore } from '@/store/conversationStore'
import { Button } from '@/components/ui/button'

const conversationStore = useConversationStore()
const selectedTab = ref('conversations')

function startNewConversation() {
  // Toggle open the bubble and navigate to it
  conversationStore.isOpen = true
}

function openConversation(conversation) {
  conversationStore.activeConversation = conversation
  conversationStore.isOpen = true
}
</script>

<template>
  <section class="mb-8 bg-white rounded-lg p-6 shadow-sm">
    <div class="mb-6">
      <h2 class="text-xl font-bold mb-4">
        Aide intelligente
      </h2>

      <!-- Tabs -->
      <Tabs v-model="selectedTab" class="w-auto">
        <TabsList>
          <TabsTrigger value="conversations">
            Conversations Wiso
          </TabsTrigger>
          <TabsTrigger value="suggestions">
            Actions suggérées
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>

    <!-- Conversations Tab Content -->
    <div v-if="selectedTab === 'conversations'">
      <div class="flex justify-between items-center mb-6">
        <!--
        <h3 class="text-lg font-medium">Conversations Wiso récentes</h3>
         -->
        <Button class="flex items-center gap-2" @click="startNewConversation">
          <Plus class="h-4 w-4" />
          Nouvelle conversation
        </Button>
      </div>

      <div v-if="conversationStore.conversations.length > 0" class="space-y-3">
        <div
          v-for="conversation in conversationStore.conversations.slice(0, 3)"
          :key="conversation.id"
          class="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer"
          @click="openConversation(conversation)"
        >
          <div class="flex justify-between items-start">
            <div>
              <h3 class="font-semibold">
                {{ conversation.title }}
              </h3>
              <p class="text-sm text-gray-600 mt-1 line-clamp-1">
                {{ conversation.lastMessage || "Pas encore de messages" }}
              </p>
            </div>
            <div class="text-xs text-gray-500">
              {{ conversationStore.formatDate(conversation.timestamp) }}
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-6 text-gray-500">
        Aucune conversation récente
      </div>

      <div
        v-if="conversationStore.conversations.length > 3"
        class="mt-4 text-center"
      >
        <Button
          variant="ghost"
          class="flex items-center gap-2 mx-auto"
          @click="startNewConversation"
        >
          Voir toutes les conversations
          <ChevronRight class="h-4 w-4" />
        </Button>
      </div>
    </div>

    <!-- Suggestions Tab Content -->
    <div v-if="selectedTab === 'suggestions'">
      <div class="space-y-3">
        <div class="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer">
          <h3 class="font-semibold">
            Suggestion 1
          </h3>
          <p class="text-sm text-gray-600 mt-1">
            Description de la suggestion avec plus de détails ici
          </p>
        </div>
        <div class="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer">
          <h3 class="font-semibold">
            Suggestion 2
          </h3>
          <p class="text-sm text-gray-600 mt-1">
            Description de la suggestion avec plus de détails ici
          </p>
        </div>
        <div class="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer">
          <h3 class="font-semibold">
            Suggestion 3
          </h3>
          <p class="text-sm text-gray-600 mt-1">
            Description de la suggestion avec plus de détails ici
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
